import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../elementals';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const EmptyState = ({ title, subtitle }) => {
    return (_jsxs("section", { className: cx('empty-text', 'u-text-center', 'u-mb-6', 'u-mt-6'), children: [_jsx(Text, { color: 'gray', as: 'h2', size: 'huge', children: title }), subtitle && (_jsx(Text, { color: 'gray', as: 'h3', size: 'big', children: subtitle }))] }));
};
export default EmptyState;
//# sourceMappingURL=index.js.map